
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Room {
  id: string;
  provider_id: string;
  name: string;
  description?: string;
  capacity: number;
  is_active: boolean;
  address?: string;
  phone?: string;
  has_device_access?: boolean;
  created_at: string;
  updated_at: string;
}

export const useRooms = (providerId?: string) => {
  return useQuery({
    queryKey: ['rooms', providerId],
    queryFn: async () => {
      if (!providerId) return [];
      
      const { data, error } = await supabase
        .from('rooms')
        .select('*')
        .eq('provider_id', providerId)
        .eq('is_active', true)
        .order('name', { ascending: true });

      if (error) {
        console.error('Error fetching rooms:', error);
        throw error;
      }

      return data as Room[];
    },
    enabled: !!providerId,
  });
};
